import { addIndex, map } from 'ramda';

export const mapIndexed = addIndex(map);

export default mapIndexed;
